import {
  Map as ImmutableMap,
  List as ImmutableList,
} from 'immutable'
import {
  TOP_FRIEND_EDITOR_RESET,
  TOP_FRIEND_EDITOR_SUGGESTIONS_READY,
  TOP_FRIEND_EDITOR_SUGGESTIONS_CLEAR,
  TOP_FRIEND_EDITOR_SUGGESTIONS_CHANGE,
} from '../actions/friends'

const initialState = ImmutableMap({
  suggestions: ImmutableMap({
    value: '',
    items: ImmutableList(),
  }),
})

export default function top_friend_editor(state = initialState, action) {
  switch(action.type) {
  case TOP_FRIEND_EDITOR_RESET:
    return initialState

  case TOP_FRIEND_EDITOR_SUGGESTIONS_CHANGE:
    return state.setIn(['suggestions', 'value'], action.value)
  case TOP_FRIEND_EDITOR_SUGGESTIONS_READY:
    return state.setIn(['suggestions', 'items'], ImmutableList(action.accounts.map(item => item.id)))
  case TOP_FRIEND_EDITOR_SUGGESTIONS_CLEAR:
    return state.update('suggestions', suggestions => suggestions.withMutations(map => {
      map.set('items', ImmutableList())
      map.set('value', '')
    }))

  default:
    return state
  }
}
